import request from '@/utils/request'
import qs from 'qs'

export function addAction(data, banner) {
    let url = '/sportPlan/addAction'
    if (data.actionId) {
        url = '/sportPlan/updateAction'
    }
    const formData = new FormData();
    formData.append('actionId', data.actionId);
    formData.append('actionName', data.actionName);
    formData.append('trainParts', data.trainParts);
    formData.append('trainMuscles', data.trainMuscles);
    formData.append('instrumentType', data.instrumentType);
    formData.append('actionIntroduce', data.actionIntroduce);
    formData.append('recordType', data.recordType);
    formData.append('customize', data.customize);
    if (banner) {
        formData.append('banner', banner);
    } else {
        formData.append('bannerUrl', data.bannerUrl);
    }
    return request({
        url: url,
        method: 'post',
        data: formData,
        headers: {
            'Content-Type': 'multipart/form-data'
        }
    })
}

export function getActionListByType(data) {
    data = qs.stringify(data)
    return request({
        url: '/sportPlan/getActionListByType',
        method: 'post',
        data
    })
}

export function getActionById(data) {
    data = qs.stringify(data)
    return request({
        url: '/sportPlan/getActionById',
        method: 'post',
        data
    })
}

export function deleteAction(data) {
    data = qs.stringify(data)
    return request({
        url: '/sportPlan/deleteAction',
        method: 'post',
        data
    })
}

export function addTrainPlan(data) {
    data = qs.stringify(data)
    return request({
        url: '/sportPlan/addTrainPlan',
        method: 'post',
        data
    })
}

export function addUserTrainPlan(data) {
    data = qs.stringify(data)
    return request({
        url: '/sportPlan/addUserTrainPlan',
        method: 'post',
        data
    })
}

export function getPlanLibrary(data) {
    data = qs.stringify(data)
    return request({
        url: '/sportPlan/getPlanLibrary',
        method: 'post',
        data
    })
}

export function getUserTrainPlan(data) {
    data = qs.stringify(data)
    return request({
        url: '/sportPlan/getUserTrainPlan',
        method: 'post',
        data
    })
}

export function getPlanLibraryById(data) {
    data = qs.stringify(data)
    return request({
        url: '/sportPlan/getPlanLibraryById',
        method: 'post',
        data
    })
}

export function getUserTrainPlanById(data) {
    data = qs.stringify(data)
    return request({
        url: '/sportPlan/getUserTrainPlanById',
        method: 'post',
        data
    })
}

export function exitUserTrainPlan(data) {
    data = qs.stringify(data)
    return request({
        url: '/sportPlan/exitUserTrainPlan',
        method: 'post',
        data
    })
}

export function checkUserTrainPlanProgress(data) {
    data = qs.stringify(data)
    return request({
        url: '/sportPlan/checkUserTrainPlanProgress',
        method: 'post',
        data
    })
}

export function deletePlan(data) {
    data = qs.stringify(data)
    return request({
        url: '/sportPlan/deletePlan',
        method: 'post',
        data
    })
}

export function addSportTrain(data) {
    data = qs.stringify(data)
    return request({
        url: '/sportPlan/addSportTrain',
        method: 'post',
        data
    })
}

export function getSportTrainById(data) {
    data = qs.stringify(data)
    return request({
        url: '/sportPlan/getSportTrainById',
        method: 'post',
        data
    })
}

export function updateFeel(data) {
    data = qs.stringify(data)
    return request({
        url: '/sportPlan/updateFeel',
        method: 'post',
        data
    })
}

export function getCalendarUserTrainPlan(data) {
    data = qs.stringify(data)
    return request({
        url: '/sportPlan/getCalendarUserTrainPlan',
        method: 'post',
        data
    })
}

export function getSportTrainByDate(data) {
    data = qs.stringify(data)
    return request({
        url: '/sportPlan/getSportTrainByDate',
        method: 'post',
        data
    })
}


// WEBPACK FOOTER //
// ./src/api/trainPlan.js